var React = require('react');

function ChevronMedium (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M145.4 136.5l-117.8 116c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L105.8 128 3.6 27.6c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0l117.8 116a12.1 12.1 0 0 1-.1 17z"}));
}

ChevronMedium.defaultProps = {"viewBox":"0 0 149 256.1"};

module.exports = ChevronMedium;

ChevronMedium.default = ChevronMedium;
